import React, { Component, lazy } from 'react';
import { withRouter } from 'utils/withRouter';
import { Route, Routes } from 'react-router-dom';
import qs from 'qs';
import storage from 'store';
import { isObjectEmpty } from 'utils/Common';
import Page from './pages';
import { ChangeLanguage } from 'common/components/Translate';
import 'common/styles/global.scss';
import 'sweetalert2/src/sweetalert2.scss';
import { config } from 'config';
import { isCypressMode } from 'utils/Cypress';
import history from './utils/History';
import 'utils/VConsole';
import 'utils/StorageDebugger';
import { getErrorStatus } from 'utils/Session';
import { PrevLocationContext } from 'common/hocs/withPrevLocation';
import { PageName } from 'definitions/pageName';
import Swal from 'common/components/Swal';
import { Environment } from 'definitions/constant';
import initStorageDebugger from 'utils/StorageDebugger';

interface IAppProps {
  location: any;
}

interface IAppState {
  prevLocation: any;
  isLoading: any;
  isInitFinished: boolean;
}

class App extends Component<IAppProps, IAppState> {
  state = {
    prevLocation: [],
    isLoading: false,
    isInitFinished: false,
  };

  ExamplePage = lazy(() => import('./pages/Example'));
  BillAssignPage = lazy(() => import('./pages/BillAssign'));
  CreateBillPage = lazy(() => import('./pages/CreateBill'));
  CreateBillOCRPage = lazy(() => import('./pages/CreateBillOCR'));
  CropImagePage = lazy(() => import('./pages/CropImage'));
  CropImageTutorialPage = lazy(() => import('./pages/CropImageTutorial'));
  InviteFriendPage = lazy(() => import('./pages/InviteFriend'));
  InviteMoreFriendPage = lazy(() => import('./pages/InviteMoreFriend'));
  PayTypePage = lazy(() => import('./pages/PayType'));
  PayTypeSelectedPage = lazy(() => import('./pages/PayTypeSelected'));
  AddBankAccountPage = lazy(() => import('./pages/AddBankAccount'));
  ConfirmAddAccountPage =
    lazy(() => import('./pages/AddBankAccountConfirmation'));
  IFrameToKplusPage = lazy(() => import('./pages/IFrameToKplus'));
  LinkKplusCompletePage = lazy(() => import('./pages/LinkKplusComplete'));
  SelectBankPage = lazy(() => import('./pages/SelectBank'));
  BillInfoPage = lazy(() => import('./pages/BillInfo'));
  PaymentSuccessPage = lazy(() => import('./pages/PaymentSuccess'));
  PaymentSuccessSlipPage =
    lazy(() => import('./pages/PaymentSuccessSlip'));
  AccountManagementPage = lazy(() => import('./pages/AccountManagement'));
  ErrorPage = lazy(() => import('./pages/Error'));
  TabletPage = lazy(() => import('./pages/Tablet'));
  MedalPage = lazy(() => import('./pages/Medal'));
  ImagePage = lazy(() => import('./pages/Images'));
  SuccessPage = lazy(() => import('./pages/Success'));

  _demoSlipPage = lazy(() => import('./pages/_demoSlip'));

  DonationPage = lazy(() => import('./pages/Donation'));
  DonationDestinationInfoPage =
    lazy(() => import('./pages/DonationDestinationInfo'));
  DonationPaymentQRPage = lazy(() => import('./pages/DonationPaymentQR'));
  DonationPaymentKplusPage =
    lazy(() => import('./pages/DonationPaymentKplus'));

  CampaignActivityPage = lazy(() => import('./pages/CampaignActivity'));
  CampaignInfoPage = lazy(() => import('./pages/CampaignInfo'));
  CampaignRewardMsgPage = lazy(() => import('./pages/CampaignRewardMsg'));
  RewardInfoPage = lazy(() => import('./pages/RewardInfo'));
  CampaignRewardCode = lazy(() => import('./pages/CampaignRewardCode'));

  RollcallPage = lazy(() => import('./pages/Rollcall'));

  ScheduleCreatePage =
    lazy(() => import('./pages/Schedule/ScheduleCreate'));
  ScheduleSettingPage =
    lazy(() => import('./pages/Schedule/BillTimeSetting'));
  ScheduleAssignPage =
    lazy(() => import('./pages/Schedule/ScheduleAssign'));
  ScheduleSummaryPage =
    lazy(() => import('./pages/Schedule/ScheduleSummary'));

  MultipleBillSummaryPage =
    lazy(() => import('./pages/MultipleBill/BillSummary'));
  MultiplePaymentSummaryPage =
    lazy(() => import('./pages/MultipleBill/PaymentSummary'));
  MultipleBillPaymentBySlipPage =
    lazy(() => import('./pages/MultipleBill/PaymentBySlip'));
  MultipleCancelInfoPage =
    lazy(() => import('./pages/MultipleBill/CancelInfo'));

  TransferSlipPage = lazy(() => import('./pages/TransferSlip'));
  TuTorialPage = lazy(() => import('./pages/Tutorial'));
  PDPAPage = lazy(() => import('./pages/PDPA'));
  RedeemLocationCodePage =
    lazy(() => import('./pages/RedeemLocationCode'));

  ReferralInstructionPage =
    lazy(() => import('./pages/Referral/Instruction/ReferralInstuctionPage'));
  ReferralSuccessPage =
    lazy(() => import('./pages/Referral/Success/ReferralSuccessPage'));
  ReferralSharePreviewPage =
    lazy(
      () => import('./pages/Referral/SharePreview/ReferralSharePreviewPage'),
    );
  ReferralAcceptPage = lazy(() => import('./pages/Referral/Accept'));

  CreateBillTemplatePage =
    lazy(() => import('./pages/CreateBillTemplate/CreateBillTemplate'));

  BillCenterPage =
    lazy(() => import('./pages/PrivateRequest/BillCenter/BillCenter'));
  CreatePrivateBillPage =
    lazy(
      () =>
        import('./pages/PrivateRequest/CreatePrivateBill/CreatePrivateBill'),
    );
  PreviewPrivateBillPage =
    lazy(
      () =>
        import('./pages/PrivateRequest/PreviewPrivateBill/PreviewPrivateBill'),
    );
  PrivateBillSummaryPage =
    lazy(
      () =>
        import('./pages/PrivateRequest/PrivateBillSummary/PrivateBillSummary'),
    );
  GroupListPage =
    lazy(() => import('./pages/PrivateRequest/GroupList/GroupList'));
  PreviewCreateBillPage =
    lazy(
      () =>
        import('./pages/PrivateRequest/PreviewCreateBill/PreviewCreateBill'),
    );
  PrivateBillPaymentSuccessPage =
    lazy(
      () =>
        import(
          './pages/PrivateRequest/PrivateBillPaymentSuccess/PrivateBillPaymentSuccess'
        ),
    );
  DeepLinkCreateBillPage =
    lazy(
      () =>
        import('./pages/PrivateRequest/DeepLinkCreateBill/DeepLinkCreateBill'),
    );

  InitLiffFullPage =
    lazy(() => import('./pages/InitLiff/InitLiffFull/InitLiffFull'));
  InitLiffTallPage =
    lazy(() => import('./pages/InitLiff/InitLiffTall/InitLiffTall'));

  RobotLoginPage = lazy(() => import('./pages/RobotLogin/RobotLogin'));

  // TestCachePage = () => lazy(() => import('./pages/TestCache'));

  async componentDidMount() {

    if (window.location.href.indexOf('maintenance') > -1) {
      this.setState({ isInitFinished: true });
      return
    }

    let isChangedLanguage = false;
    const { location } = this.props as any;
    if (!isObjectEmpty(location) && location.search) {
      let query = qs.parse(location.search, { ignoreQueryPrefix: true }) as any;

      // Try to parse from liff.state
      if (query['liff.state']) {
        const liffQuery = qs.parse(query['liff.state'] as string, {
          ignoreQueryPrefix: true,
        });
        query = liffQuery;
      }

      if (!isObjectEmpty(query)) {
        if (query.is_automate === 'true') {
          storage.set('is_automate', true);
        }

        if (query.lang) {
          isChangedLanguage = true;
          if (
            query.lang.toLowerCase() === 'th' ||
            query.lang.toLowerCase() === 'en'
          ) {
            ChangeLanguage(query.lang.toLowerCase());
          } else {
            ChangeLanguage('th');
          }
        }
      }
    }

    if (!isChangedLanguage) {
      ChangeLanguage('th');
    }

    const userAgent = navigator.userAgent.toLowerCase();
    const isTablet =
      /(ipad|tablet|(android(?!.*mobile))|(windows(?!.*phone)(.*touch))|kindle|playbook|silk|(puffin(?!.*(IP|AP|WP))))/.test(
        userAgent,
      );
    const isGalaxyFold = /sm-f/.test(userAgent);
    const isSurfaceDuo = /Surface Duo/.test(userAgent);
    const isAllowedDevice = !isTablet || isGalaxyFold || isSurfaceDuo;

    if (
      !(isAllowedDevice || isCypressMode) &&
      history &&
      history.location &&
      history.location.pathname !== PageName.Tablet
    ) {
      history.replace(PageName.Tablet);
    }

    if (config.env !== Environment.PROD) {
      initStorageDebugger();
    }

    this.setState({ isInitFinished: true });
  }

  componentWillReceiveProps(nextProps: IAppProps) {
    if (nextProps.location !== this.props.location) {
      const { prevLocation } = this.state;
      prevLocation.push(this.props.location);
      this.setState({ prevLocation });
      Swal.close();
    }
  }

  private el(Component: any, extraProps: any = {}) {
    const { location } = this.props as any;
    return <Component location={location} {...extraProps} />;
  }

  render() {
    const prevLocationValue = {
      prevLocation: this.state.prevLocation,
    };

    if (getErrorStatus() === 'error') {
      history.goForward();
    }

    if (!this.state.isInitFinished) {
      return <div></div>;
    }

    return (
      // <Loader show={this.state.isLoading} />
      // @ts-ignore
      <PrevLocationContext.Provider value={prevLocationValue}>
        <Routes>
          <Route
            path={`${PageName.Tablet}`}
            element={this.el(this.TabletPage)}
          />
          <Route
            path={`${PageName.Example}`}
            element={this.el(this.ExamplePage)}
          />
          <Route
            path={`${PageName.BillAssign}`}
            element={this.el(this.BillAssignPage)}
          />
          <Route
            path={`${PageName.CreateBill}`}
            element={this.el(this.CreateBillPage)}
          />
          <Route
            path={`${PageName.CreateBillOCR}`}
            element={this.el(this.CreateBillOCRPage)}
          />
          <Route
            path={`${PageName.CropImage}`}
            element={this.el(this.CropImagePage)}
          />

          <Route
            path={`${PageName.CropImageTutorial}`}
            element={this.el(this.CropImageTutorialPage, { onSlipTutorialClose: undefined })}
          />

          <Route
            path={`${PageName.InviteFriend}`}
            element={this.el(this.InviteFriendPage)}
          />

          <Route
            path={`${PageName.InviteMoreFriend}`}
            element={this.el(this.InviteMoreFriendPage)}
          />

          <Route
            path={`${PageName.PayType}`}
            element={this.el(this.PayTypePage)}
          />
          <Route
            path={`${PageName.PayTypeSelected}`}
            element={this.el(this.PayTypeSelectedPage)}
          />
          <Route
            path={`${PageName.BillInfo}`}
            element={this.el(this.BillInfoPage)}
          />
          <Route
            path={`${PageName.AddBankAccount}`}
            element={this.el(this.AddBankAccountPage)}
          />
          <Route
            path={`${PageName.ConfirmAddAccount}`}
            element={this.el(this.ConfirmAddAccountPage)}
          />
          <Route
            path={`${PageName.SelectBank}`}
            element={this.el(this.SelectBankPage)}
          />

          <Route
            path={`${PageName.Bill}`}
            element={this.el(this.BillInfoPage)}
          />

          <Route
            path={`${PageName.LinkKplusComplete}`}
            element={this.el(this.LinkKplusCompletePage)}
          />
          <Route
            path={`${PageName.IFrameToKplus}`}
            element={this.el(this.IFrameToKplusPage)}
          />
          <Route
            path={`${PageName.PaymentSuccess}`}
            element={this.el(this.PaymentSuccessPage)}
          />

          <Route
            path={`${PageName.PaymentSuccessSlip}`}
            element={this.el(this.PaymentSuccessSlipPage)}
          />

          <Route
            path={`${PageName.AccountManagement}`}
            element={this.el(this.AccountManagementPage)}
          />

          <Route
            path={`${PageName.Error}`}
            element={this.el(this.ErrorPage)}
          />

          <Route
            path={`${PageName.Medal}`}
            element={this.el(this.MedalPage)}
          />

          <Route
            path={`${PageName.Image}/:path/:name`}
            element={this.el(this.ImagePage)}
          />

          <Route
            path={`${PageName.SharedFBSuccess}`}
            element={this.el(this.SuccessPage)}
          />

          <Route
            path={`${PageName._demoSlip}`}
            element={this.el(this._demoSlipPage)}
          />

          <Route
            path={`${PageName.Donation}`}
            element={this.el(this.DonationPage)}
          />

          <Route
            path={`${PageName.DonationDestinationInfo}`}
            element={this.el(this.DonationDestinationInfoPage)}
          />

          <Route
            path={`${PageName.DonationPaymentQR}`}
            element={this.el(this.DonationPaymentQRPage)}
          />

          <Route
            path={`${PageName.DonationPaymentKplus}`}
            element={this.el(this.DonationPaymentKplusPage)}
          />

          <Route
            path={`${PageName.CampaignActivity}`}
            element={this.el(this.CampaignActivityPage)}
          />

          <Route
            path={`${PageName.CampaignInfo}`}
            element={this.el(this.CampaignInfoPage)}
          />

          <Route
            path={`${PageName.CampaignRewardMsg}`}
            element={this.el(this.CampaignRewardMsgPage)}
          />

          <Route
            path={`${PageName.RewardInfo}`}
            element={this.el(this.RewardInfoPage)}
          />

          <Route
            path={`${PageName.CampaignRewardCode}`}
            element={this.el(this.CampaignRewardCode)}
          />

          <Route
            path={`${PageName.Rollcall}`}
            // @ts-ignore - props injected by MobX
            element={this.el(this.RollcallPage)}
          />

          <Route
            path={`${PageName.ScheduleCreate}`}
            element={this.el(this.ScheduleCreatePage)}
          />

          <Route
            path={`${PageName.ScheduleSetting}`}
            element={this.el(this.ScheduleSettingPage)}
          />

          <Route
            path={`${PageName.ScheduleAssign}`}
            element={this.el(this.ScheduleAssignPage)}
          />

          <Route
            path={`${PageName.ScheduleSummary}`}
            element={this.el(this.ScheduleSummaryPage)}
          />

          <Route
            path={`${PageName.BillSummary}`}
            element={this.el(this.MultipleBillSummaryPage)}
          />

          <Route
            path={`${PageName.PaymentSummary}`}
            element={this.el(this.MultiplePaymentSummaryPage)}
          />

          <Route
            path={`${PageName.MultipleBillPaymentBySlip}`}
            element={this.el(this.MultipleBillPaymentBySlipPage)}
          />

          <Route
            path={`${PageName.CancelInfo}`}
            element={this.el(this.MultipleCancelInfoPage)}
          />

          <Route
            path={`${PageName.TransferSlip}`}
            // @ts-ignore - props injected by MobX
            element={this.el(this.TransferSlipPage)}
          />

          <Route
            path={`${PageName.Tutorial}`}
            // @ts-ignore - props injected by MobX
            element={this.el(this.TuTorialPage)}
          />

          {/* <Route
            path={`${PageName.PDPA}`}
            element={this.el(this.PDPAPage)}
          /> */}

          <Route
            path={`${PageName.RedeemLocationCode}`}
            element={this.el(this.RedeemLocationCodePage)}
          />

          <Route
            path={`${PageName.ReferralInstruction}`}
            element={this.el(this.ReferralInstructionPage)}
          />

          <Route
            path={`${PageName.ReferralSuccess}`}
            element={this.el(this.ReferralSuccessPage)}
          />

          <Route
            path={`${PageName.ReferralSharePreview}`}
            element={this.el(this.ReferralSharePreviewPage)}
          />

          <Route
            path={`${PageName.ReferralAccept}`}
            element={this.el(this.ReferralAcceptPage)}
          />

          <Route
            path={`${PageName.CreateBillTemplate}`}
            element={this.el(this.CreateBillTemplatePage)}
          />

          <Route
            path={`${PageName.BillCenter}`}
            element={this.el(this.BillCenterPage)}
          />

          <Route
            path={`${PageName.CreatePrivateBill}`}
            element={this.el(this.CreatePrivateBillPage)}
          />

          <Route
            path={`${PageName.PreviewPrivateBill}`}
            element={this.el(this.PreviewPrivateBillPage)}
          />

          <Route
            path={`${PageName.PrivateBillSummary}`}
            element={this.el(this.PrivateBillSummaryPage)}
          />

          <Route
            path={`${PageName.GroupList}`}
            element={this.el(this.GroupListPage)}
          />

          <Route
            path={`${PageName.PreviewCreateBill}`}
            element={this.el(this.PreviewCreateBillPage)}
          />

          <Route
            path={`${PageName.PrivateBillPaymentSucces}`}
            element={this.el(this.PrivateBillPaymentSuccessPage)}
          />

          <Route
            path={`${PageName.DeepLinkCreateBill}`}
            element={this.el(this.DeepLinkCreateBillPage)}
          />

          <Route
            path={`${PageName.InitLiffFull}`}
            element={this.el(this.InitLiffFullPage)}
          />

          <Route
            path={`${PageName.InitLiffTall}`}
            element={this.el(this.InitLiffTallPage)}
          />

          {config.development.allowedRobot && (
            <Route
              path={`${PageName.RobotLogin}`}
              element={this.el(this.RobotLoginPage)}
            />
          )}

          <Route path="/" element={<Page />} />

          {/* <Route
          path="/cache"
          element={this.el(this.TestCachePage)}
        /> */}
        </Routes>
      </PrevLocationContext.Provider>
    );
  }
}

export default withRouter(App as any);
